import KeyM1 from '../../../assets/volca_slices/key_m1.png'
import KeyM2 from '../../../assets/volca_slices/key_m2.png'
import KeyM3 from '../../../assets/volca_slices/key_m3.png'
import KeyM4 from '../../../assets/volca_slices/key_m4.png'
import KeyM5 from '../../../assets/volca_slices/key_m5.png'
import KeyM6 from '../../../assets/volca_slices/key_m6.png'
import KeyM7 from '../../../assets/volca_slices/key_m7.png'
import KeyM8 from '../../../assets/volca_slices/key_m8.png'
import Key9 from '../../../assets/volca_slices/key_9.png'
import Key10 from '../../../assets/volca_slices/key_10.png'
import Key11 from '../../../assets/volca_slices/key_11.png'
import Key12 from '../../../assets/volca_slices/key_12.png'
import Key13 from '../../../assets/volca_slices/key_13.png'
import Key14 from '../../../assets/volca_slices/key_14.png'
import Key15 from '../../../assets/volca_slices/key_15.png'
import Key16 from '../../../assets/volca_slices/key_16.png'

const KeyImages = [
    KeyM1, 
    KeyM2, 
    KeyM3, 
    KeyM4, 
    KeyM5, 
    KeyM6, 
    KeyM7, 
    KeyM8, 
    Key9, 
    Key10, 
    Key11, 
    Key12, 
    Key13, 
    Key14, 
    Key15, 
    Key16,
]

export default KeyImages;